export const mappedCurrencies = {
  uk: 'GBP',
  fr: 'EUR',
  de: 'EUR',
} as const;

export const fallBackCurrency = 'EUR';
